import { IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { IContentTileExpectedObj } from 'ui-ng-content-tile';
import { IDatasource, Query } from 'utility-ts-orm';
import { HoldsAttentionServant } from '../servants/holds_attention_servant';
import { Hold } from './../builders/holds_builder';
import { HoldsConfigService } from './../servants/holds_config_servant';

export class HoldPriorityFeedQuery implements IQuery {
  private _result: IContentTileExpectedObj;
  private _count: number;
  private _needsAttentionCount: number;
  private _hasAttentionHold: boolean;

  constructor(private ngHoldDatastore: IDatasource<Hold>, private holdsConfigService: HoldsConfigService) {
    Query.registerQuery(this, this.ngHoldDatastore);
  }

  _priorotyFeedObjectBuilder(needsAttention: Hold[], regular: Hold[]) {
    const title = this._priorityFeedTitleBuilder(needsAttention.length, regular.length);
    const action = this._priorityFeedAction(needsAttention, regular);
    const icon = HoldsAttentionServant.getHoldIcon(_4.first(needsAttention));
    let subTitle = this._count === 1 ? `Here's how to resolve it` : `Here's how to resolve them`;
    if (this._needsAttentionCount > 0) {
      subTitle += ` as soon as possible`;
    }

    return { text: { title, subTitle }, action, icon };
  }

  run(): this {
    const needsAttentionHolds = this.ngHoldDatastore.query((holdItem: Hold) =>
      HoldsAttentionServant.isHoldThatRequiresAttention(holdItem)
    );
    const regularHolds = this.ngHoldDatastore.query((holdItem: Hold) => HoldsAttentionServant.isRegularHold(holdItem));

    this._count = needsAttentionHolds.length + regularHolds.length;
    this._needsAttentionCount = needsAttentionHolds.length;
    this._hasAttentionHold = !_4.isEmpty(needsAttentionHolds);

    const isActive = this._count > 0;
    const { action, text, icon } = this._priorotyFeedObjectBuilder(needsAttentionHolds, regularHolds);
    this._result = {
      icon,
      action,
      text,
      isOverdue: false,
      isActive
    };

    return this;
  }

  private _priorityFeedTitleBuilder(needsAttention: number, regularHolds: number) {
    const hasNeedsAttentionHold = needsAttention > 0;
    const hasRegularHold = regularHolds > 0;
    const hasBothHoldTypes = hasNeedsAttentionHold && hasRegularHold;

    if (!hasNeedsAttentionHold && !hasRegularHold) {
      return ``;
    }

    const hasManyHighPriorityHolds = needsAttention > 1;
    const hasManyLowPriorityHolds = regularHolds > 1;

    const needsAttentionHoldText =
      `${needsAttention} hold${hasManyHighPriorityHolds ? 's' : ''} ` +
      `that need${hasManyHighPriorityHolds ? '' : 's'} attention`;

    const regularHoldText =
      `${regularHolds} ${hasNeedsAttentionHold ? 'additional ' : ''}` + `hold${hasManyLowPriorityHolds ? 's' : ''}`;

    return (
      `You have ${hasNeedsAttentionHold ? needsAttentionHoldText : ''}` +
      `${hasBothHoldTypes ? ' and ' : ''}` +
      `${hasRegularHold ? regularHoldText : ''}`
    );
  }

  private _priorityFeedAction(needsAttention: Hold[], reulgarHolds: Hold[]) {
    if (this._count !== 1) {
      return { state: this.holdsConfigService.centerRoute };
    }

    let currentHold;
    if (reulgarHolds.length === 1) {
      currentHold = _4.first(reulgarHolds);
    }
    if (needsAttention.length === 1) {
      currentHold = _4.first(needsAttention);
    }

    return HoldsAttentionServant.getHoldRoutingDetails(currentHold as Hold, this.holdsConfigService);
  }

  get count() {
    return this._count;
  }

  get needsAttentionCount() {
    return this._needsAttentionCount;
  }

  get requiresAttention() {
    return this._hasAttentionHold;
  }

  get result() {
    return this._result;
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-holds/src/queries/holds_priority_feed_query.ts